import React from 'react';
import Layout from '../../shared/components/Layout';
import Complete from '@/components/Complete';

const LostNonWarrantyRequestComplete: React.FC = () => {
  return (
    <React.Fragment>
      <Layout>
        <Complete id="page-facility_login" heading="紛失・保証外レンズ申込確定完了" content="紛失・保証外レンズ申込の確定が完了しました。"isFacility={false}  />
      </Layout>
    </React.Fragment>
  )
}

export default LostNonWarrantyRequestComplete;